<template>
  <div id="app">
    <header-nav v-show="$route.meta.navShow"></header-nav>
    <keep-alive :include="include" >
      <router-view />
    </keep-alive>
    <footer-nav></footer-nav>
    <!-- <el-backtop target="#app" :bottom="15" :left="30">
      <div
        style="{
          height: 40px;
          width:40px;
          background-color: #962bb1;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          line-height: 40px;
        }"
      >
        <i class="el-icon-arrow-up"></i>
      </div>
    </el-backtop> -->
    <!-- <div class="left-service">
      <img @click="goservice" src="./assets/images/home/24h.png" alt />
    </div> -->
    <aside-pendant v-show="!$route.meta.asideHide"></aside-pendant>
    <register></register>
    <login></login>
    <service-floater></service-floater>
  </div>
</template>

<script>
/*eslint-disable*/
import momentTimezone from 'moment-timezone';
import HeaderNav from './components/Header/Header'
import FooterNav from './components/footer/footer'
import {mapState, mapActions , mapMutations} from 'vuex';
import {gameMaintain} from '@/common/mixins';
import AsidePendant from './components/pendant/aside-pendant'
import register from './components/common/register/register'
import login from './components/common/register/login'
import serviceFloater from './components/common/serviceFloater'
import {  common  } from '@/common/index';
function onVisibilityChanged(data) {
  switch (data.visibility) {
    case "maximized":
      break;
    case "minimized":
      break;
    case "hidden":
      break;
  }
}
export default {
  name: 'App',
  mixins: [gameMaintain],
  components: {
    AsidePendant,
    FooterNav,
    HeaderNav,
    register,
    login,
    serviceFloater
  },
  data() {
    return {
      include: ['HOME', 'fish-page', 'chess-page', 'liveCasino', 'lottery-page', 'sports-page', 'privilege', 'slot-page','discountsHall'],
      timer: '',
      moneyTimer: '',
      // drawer: null,
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' },
      ],
    };
  },
  computed: {
    ...mapState({
      jin_sha_global_login_state: state=>state.jin_sha_global_login_state,
      UUID: state=>state.UUID,
      isLogin: state=>state.isLogin,
      drawer: state=>state.drawer,
      customer_service_system_link: state => state.FrontConfigList.customer_service_system_link,
      LiveChat: state => state.FrontConfigList.LiveChat,
      userName: (state) => state.userInfo.userInfo.userAccount,
    })
  },
  methods: {
    ...mapMutations(['setIsLanguage']),
    ...mapActions(['newinitLinkList','initLinkList', 'getFirstNav', 'maintainGameList' ,'addJackPotMoney', 'checkLogin', 'getFirstInfo','getInEmail','getBonusInfo']),
    // goservice(){
    //   common.goHref(this.customer_service_system_link)
    // },
    refreshUserInfo() {
      let params = {
        UUID: this.UUID,
      };
      this.$api.post(this.$urls.HOMEAFTER.refreshUserInfo,params,resp=>{},err=>{})
    },
    IsPC() {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone",
          "SymbianOS", "Windows Phone",
          "iPad", "iPod"];
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  watch: {
     isLogin:{
      handler(newV,oldV) {
        if(newV){
          this.getInEmail()
          this.refreshUserInfo()
          this.getFirstInfo()
          this.timer = setInterval(()=>{
            this.refreshUserInfo()
          },1000*60*5)
        }else{
          // this.$router.push({path:'/'})
          clearInterval(this.timer);
          this.timer = ''
        }
      },immediate: true
    },
  },
  mounted() {
    this.maintainGameList()
    this.newinitLinkList();
    this.initLinkList();
    this.getFirstNav();
    this.checkLogin();
    this.moneyTimer = setInterval(() => {
      this.addJackPotMoney()
    },1000*3);
  },

  created() {
    momentTimezone.tz.setDefault("Asia/Calcutta");
    // window.LiveChatWidget ? window.LiveChatWidget.call('hide') : '';
    // window.LiveChatWidget.on("visibility_changed", function(data) {
    //   console.log(data)
    //   if (data.visibility === "minimized") {
    //     window.LiveChatWidget.call('hide')
    //   }
    // });
    let lang = this.$Cookies.get('lang')
    if(lang){
      this.$i18n.locale = lang || 'en_US'  //英文
      this.setIsLanguage(lang)
    }else{
      let navigatorLang = window.navigator.language;
      if(navigatorLang == 'en'){
        this.$Cookies.set('lang','en_US');
        this.$i18n.locale = 'en_US'
        this.setIsLanguage('en_US')
      }else if(navigatorLang == 'hi'){
        this.$Cookies.set('lang','hi_IN');
        this.$i18n.locale = 'hi_IN'
        this.setIsLanguage('hi_IN')  
      }else{
        this.$Cookies.set('lang','en_US');
        this.$i18n.locale = 'en_US'
        this.setIsLanguage('en_US') 
      }
    }
    // 优惠类型
    this.getBonusInfo()
  }
};
</script>

<style lang="scss">
@import "./style/index.scss";
body{
   background:  $color-background;
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/App.vue